export default "__VITE_ASSET__DWx0PKB3__"